import { render, staticRenderFns } from "./SpecializationForm.vue?vue&type=template&id=ffe1e2ca"
import script from "./SpecializationForm.vue?vue&type=script&lang=js"
export * from "./SpecializationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports